import React from "react";

import { ImageArticle, ImageArticleType } from "./image";
import { Regular, RegularArticleType } from "./regular";
import { VideoArticle, VideoArticleType } from "./video";
import {
    InboxEsportRewatchMatchArticleType,
    RewatchMatchEntry,
} from "./rewatch-match";

type ListArticleType = {
    data:
        | ImageArticleType
        | RegularArticleType
        | VideoArticleType
        | InboxEsportRewatchMatchArticleType;
};

export const ListArticle = ({ data }: ListArticleType) => {
    const { type } = data;

    switch (type) {
        case "liveStreamCommunityEntry":
            return (
                <VideoArticle
                    {...data}
                    categories={[]}
                    live={true}
                    postDate={undefined}
                />
            );
        case "communityEntry":
            return (
                <VideoArticle {...data} categories={[]} postDate={undefined} />
            );

        case "externalNewsEntry":
            return <Regular {...data} external={true} />;
        case "esportRewatchMatchEntry":
            return <RewatchMatchEntry {...data} />;
        case "imageNewsEntry":
            return <ImageArticle {...data} />;
        case "videoNewsEntry":
            return <VideoArticle {...data} />;
        case "esportNewsEntry":
        case "newsEntry":
            return <Regular {...data} />;

        default:
            return <div>[MISSING COMPONENT]</div>;
    }
};
